import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './FreeSpinLauncher.css';

function FreeSpinLauncher({ visible = true, label = 'Free Spin', isLoggedIn = false }) {
  const navigate = useNavigate();
  const [closed, setClosed] = useState(false);
  const [showGuestMsg, setShowGuestMsg] = useState(false);

  if (!visible || closed) return null;

  const onLauncherClick = () => {
    if (isLoggedIn) {
      navigate('/free-spin');
    } else {
      setShowGuestMsg(true);
    }
  };

  const onClose = () => {
    setShowGuestMsg(false);
    setClosed(true);
  };

  const goLogin = () => navigate('/login');
  const goSignup = () => navigate('/signup');

  return (
    <div className="fs-float-launcher" aria-label="free-spin-launcher">
      <button type="button" className="fs-float-close" onClick={onClose} aria-label="Close Free Spin">×</button>
      <img
        className="fs-float-logo"
        src={`${process.env.PUBLIC_URL}/poster/freespin.gif`}
        alt="Free Spin"
        onClick={onLauncherClick}
      />

      {!isLoggedIn && showGuestMsg && (
        <div className="fs-login-msg">
          <div className="fs-msg-text">Login or Sign Up to play {label}</div>
          <div className="fs-msg-actions">
            <button type="button" className="fs-msg-btn" onClick={goLogin}>Login</button>
            <button type="button" className="fs-msg-btn primary" onClick={goSignup}>Sign Up</button>
          </div>
        </div>
      )}
    </div>
  );
}

FreeSpinLauncher.propTypes = {
  visible: PropTypes.bool,
  label: PropTypes.string,
  isLoggedIn: PropTypes.bool,
};

export default FreeSpinLauncher;
